function MemberOptionsProvider() {
    'ngInject';

    const options = {
        ssoErrorRedirectPage: null
    };

    this.setOption = function (option, value) {
        if (options.hasOwnProperty(option)) {
            options[option] = value;
        }
    };

    this.getOption = function (option) {
        if (options.hasOwnProperty(option)) {
            return options[option];
        }
    };
    this.$get = () => options;
}

/**
 * @ngdoc service
 * @module BBMember
 * @name MemberOptionsProvider
 *
 * @description
 * Returns a set of Member configuration options
 */
angular
    .module('BBMember')
    .provider('MemberOptions', MemberOptionsProvider);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/member/_services/member_options.provider.js